// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__32TvR","Success":"Button_Success__DT5dy","Danger":"Button_Danger__2SIF_"};